export const calculateMargin = (price: number, cost: number): string => {
  if (price && cost && price > 0) {
    return (((price - cost) / price) * 100).toFixed(1);
  }
  return "0";
};

export const formatDate = (dateString: string): string => {
  if (!dateString) return "N/A";
  return new Date(dateString).toLocaleString("en-GB", {
    day: "2-digit",
    month: "short",
    year: "numeric",
    hour: "2-digit",
    minute: "2-digit",
    hour12: false,
  });
};

export const copyToClipboard = async (text: string): Promise<void> => {
  await navigator.clipboard.writeText(text);
};